<template>
  <div class="col-xs-12 pointer text-center">
    <button type="submit" :id="id" class="btn btn-primary btn-block" :disabled="loading">
      <span v-if="!loading"><slot>Submit</slot></span>
      <span v-else>
        <i class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></i>
        <span class="sr-only">Loading...</span>
      </span>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'submit-button',
    props: {
      id: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// SubmitButton.vue?f6906706